module.exports = __webpack_public_path__ + "static/img/kongtiao-tongfeng-active.1c6f295c.png";